import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../TravelArrangements/TravelArrangementFaq/TravelArrangementFaq.css";

const RestrictionsFaq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      question: "What is your cancellation policy?",
      answer:
        "The cancellation policy varies from one package to another. Ask your executive while booking a package.",
    },
    {
      question: "Do you offer any group packages?",
      answer:
        "Yes, we offer tailored group packages based on travelers’ requirements. Whether you’re traveling with your friends, family, or colleagues, we can customize a package for you accordingly.",
      // question: "Do I need special insurance coverage for COVID-19 when traveling?",
      // additionalQuestion: "What should I do if restrictions change while I’m traveling?",
      // answer: "Yes, many destinations now require travelers to have travel insurance that covers COVID-19 related expenses, including medical treatment and quarantine costs. "
    },
    {
      question:
        "Can you tailor a travel package to meet my specific interests and budget?",
      // additionalQuestion: "Are there any specific qualifications required?",
      answer:
        "We offer a wide variety of packages that can align with your travel plans. Nonetheless, in case you want a package based on your specific interests and budget, we can do that for you, too.",
    },
    {
      question: "Are there restrictions on bringing certain items into UAE?",
      // additionalQuestion: "Can I apply for multiple positions at once?",
      answer:
        "Many countries have restrictions on items such as food, plants, and large amounts of currency. Check the customs regulations of your destination before hand to ensure compliance.",
    },
    {
      question:
        "How can I contact your customer service team if I need assistance?",
      // additionalQuestion: "How long does the process usually take?",
      answer:
        "You can write to us at info@blueberry-travel.com or call us at +971-4770-7355 (UAE) or +91-97733-03363 (IND).",
    },
    {
      question: "What is your response time for customer inquiries?",
      // additionalQuestion: "How long does the process usually take?",
      answer:
        "If your call isn’t answered, our team will get back to you within 24 hours. ",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="container ta-faq">
      <h2 className="headings mt-2 mx-3 safetyCardHeading">
        <span>Frequently</span> Asked Questions
      </h2>
      <div className="travelfaq-list">
        {questions.map((item, index) => (
          <div
            key={index}
            className={`travelfaq-item ${
              activeIndex === index ? "active" : ""
            }`}
          >
            <div
              className="travelfaq-question fw-bold "
              onClick={() => toggleFAQ(index)}
            >
              {item.question}
              <LazyLoadImage
                src={
                  activeIndex === index
                    ? "https://blueberrywebsites.azureedge.net/bbt/images/faqMInus.png"
                    : "https://blueberrywebsites.azureedge.net/bbt/images/faqAdd.png"
                }
                alt={activeIndex === index ? "Collapse" : "Expand"}
                className="travelFaqIcon"
                loading="lazy"
              />
            </div>
            {activeIndex === index && (
              <div className="travelfaq-answer">
                <div className="travelfaq-note">
                  <strong>{item.additionalQuestion}</strong>
                </div>
                <div>{item.answer}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RestrictionsFaq;
